import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=dbc91bc6&scoped=true&lang=pug&"
import script from "./page-not-found.vue?vue&type=script&lang=js&"
export * from "./page-not-found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc91bc6",
  null
  
)

export default component.exports